import React from 'react'
import FileDetails from '../../src/components/file_details'
import Layout from '../../src/components/layout/layout'
import { useRouter } from 'next/router'

export default function Home() {
    const router = useRouter()

    return (
        <Layout title="Details">
            <FileDetails query={router.query}/>
        </Layout>
    )
}